import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {
  Card,
  CardImg,
  CardFooter,
  Label,
  InputGroup,
  Input,
  Button,
  Alert
} from 'reactstrap'
import Cropper from 'react-cropper'
import '../../../node_modules/cropperjs/dist/cropper.css'

class FieldSingleImage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      editMode: false,
      src: null,
      imagePath: this.props.cardField.fieldValue
    }

    this.returnValue = this.returnValue.bind(this)
    this.switchToUploadMode = this.switchToUploadMode.bind(this)
    this.handleRemoveButton = this.handleRemoveButton.bind(this)
    this.handleFileUpload = this.handleFileUpload.bind(this)
    this.handleCropImage = this.handleCropImage.bind(this)
  }

  returnValue() {
    return this.state.imagePath
  }

  switchToUploadMode(ev) {
    ev.preventDefault()

    this.setState({
      editMode: true
    })
  }

  handleRemoveButton(ev) {
    ev.preventDefault()

    this.setState({
      src: null,
      imagePath: null
    })
  }

  handleFileUpload(ev) {
    ev.preventDefault()

    let files
    if (ev.dataTransfer) {
      files = ev.dataTransfer.files
    } else if (ev.target) {
      files = ev.target.files
    }

    if (files[0].size > 5 * 1024 * 1024) {
      window.alert('Ihr Bild ist größer als 5MB!')
      return false
    }

    const reader = new FileReader()
    reader.onload = () => {
      this.setState({ src: reader.result })
    }

    reader.readAsDataURL(files[0])
  }

  handleCropImage(ev) {
    ev.preventDefault()

    if (typeof this.cropper.getCroppedCanvas() === 'undefined') {
      return
    }

    this.setState({
      editMode: false,
      imagePath: this.cropper.getCroppedCanvas().toDataURL('image/jpeg')
    })
  }

  render() {
    let fieldClassName = `card-field field-image ${(this.props.cardField.fieldClassName ? this.props.cardField.fieldClassName : '')}`
        fieldClassName += (this.isEditing && this.state.src) || (!this.isEditing && this.state.imagePath) ? ' has-image' : ' no-image'

    return this.props.isEditing || this.props.cardType === 'always-on' ? <div className={fieldClassName}>
      <Label for={this.props.cardField.id}>{this.props.cardField.fieldLabel}</Label>
      {this.props.cardField.fieldSublabel && <p className='form-control-sublabel'>{this.props.cardField.fieldSublabel}</p>}
      <Alert color="info">Bitte beachten Sie die Bildanforderungen. Format: JPG, PNG. Größe: max. 5 MB</Alert>
      {this.state.imagePath && !this.state.editMode ?
      <Card key={`input-${this.props.cardField.id}`} className="mb-3">
        <div className="image-area">
          <img src={this.state.imagePath} />
        </div>
        <CardFooter>
          <Button color="primary" onClick={this.switchToUploadMode}><i className="icon-cloud-upload"></i> Bild ändern</Button>
          <Button color="danger float-right" onClick={this.handleRemoveButton}><i className="icon-trash"></i></Button>
        </CardFooter>
      </Card>
      :
      <Card key={`input-${this.props.cardField.id}`} className={`mb-3${this.state.src ? ' has-image' : ' no-image'}`}>
        <Cropper
          key='cropper'
          ref={cropper => { this.cropper = cropper }}
          className="image-area"
          guides={false}
          src={this.state.src}
          aspectRatio={this.props.cardField.imageAspectRatio || 16/9}
          background={false}
          zoomable={false}
          viewMode={1}
          />
        <CardFooter>
            <input key="fileUpload" type="file" onChange={this.handleFileUpload} accept="image/*" />
            {this.state.src !== null && <Button color="primary float-right" onClick={this.handleCropImage}><i className="icon-cloud-upload"></i> Zuschneiden</Button>}
        </CardFooter>
      </Card>
      }
    </div> : <div className={fieldClassName}>
      <Label for={this.props.cardField.id}>{this.props.cardField.fieldLabel}</Label>
      {this.props.cardField.fieldValue ?
        <div className="image-area mb-3">
          <img src={this.props.cardField.fieldValue} />
        </div>
        :
        <div className="no-image mb-3"><div className="image-area"></div></div>
      }
    </div>
  }
}

FieldSingleImage.propTypes = {
  cardField: PropTypes.object,
  isEditing: PropTypes.bool,
  cardType: PropTypes.string
}

FieldSingleImage.defaultProps = {
  cardField: {
    cardSublabel: ''
  }
}

export default FieldSingleImage


// WEBPACK FOOTER //
// ./src/components/EditableCard/FieldSingleImage.js